import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { DialogContent, Grid, Typography } from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles(theme => ({}));

const Done = props => {
    const { className, ...rest } = props;

    const classes = useStyles();

    return (
        <DialogContent>
            <Grid container direction="column" spacing={3} justify="center" alignItems="center">
                <Grid item>
                    <CheckCircleIcon style={{ color: 'green', fontSize: 42 }} size={60} />
                </Grid>
                <Grid item>
                    <Typography variant="body1">Génération terminée avec succès</Typography>
                </Grid>
            </Grid>
        </DialogContent>
    );
};

export default Done;
